import { Input } from './input.component';
import type { InputProps } from './types';

export const PasswordInput = (props: InputProps<'password'>) => <Input {...props} type='password' />;
